import {Alert} from "@/components/alert/Alert.tsx";

interface PSReportRuntimeErrorsProps {
  runtimeError?: {
    message: string;
  };
}

export const PSReportRuntimeErrors = ({runtimeError}: PSReportRuntimeErrorsProps) => {
  if (!runtimeError) {
    return null;
  }

  return (
    <Alert key="error-msg" variant={"error"}>
      {runtimeError.message}
    </Alert>
  );
};
